import { Button, useIsMobile } from '@yes.technology/react-toolkit'
import { useCallback } from 'react'
import { useTranslation } from 'react-i18n-lite'
import { useSearchParams } from 'react-router-dom'
import useStyleMaps, { StyleMap } from 'site/Renderer/hooks/useStyleMap'
import { CenteredText, MainContainer } from './Unauthorized.styles'
import UnauthorizedDesktop from './assets/unauthorized-desktop.png'
import UnauthorizedMobile from './assets/unauthorized-mobile.png'
import { useLocales } from 'locales/hooks'

export interface UnauthorizedProps {
  des?: string
  complement?: string
  action?: string
  imageSrc?: string
  imageAlt?: string
  styleMap?: StyleMap
  disabled?: boolean
  actionCallback?: VoidFunction
}

const Unauthorized = ({
  des,
  complement,
  action,
  imageSrc,
  imageAlt,
  styleMap,
  disabled = false,
  actionCallback
}: UnauthorizedProps) => {
  const styleProps = useStyleMaps(styleMap)
  const [params] = useSearchParams()
  const isMobile = useIsMobile()
  const { t } = useTranslation()

  const { getSitemodelByLocale } = useLocales()

  const getImageSrc = useCallback(() => {
    if (imageSrc) return imageSrc

    return isMobile ? UnauthorizedMobile : UnauthorizedDesktop
  }, [imageSrc, isMobile])

  const redirectToLogin = useCallback(() => {
    const redirectOrigin = params.get('redirectOrigin')

    const redirectSubUri = redirectOrigin
      ? `?redirectOrigin=${encodeURIComponent(redirectOrigin)}`
      : `?redirectOrigin=${encodeURIComponent(window.location.origin)}`

    const authSitemodelUuid = getSitemodelByLocale({
      demand: 'authSitemodelUuid'
    })

    window.location.replace(`${authSitemodelUuid}${redirectSubUri}`)
  }, [getSitemodelByLocale, params])

  return (
    <MainContainer style={styleProps}>
      <img src={getImageSrc()} alt={imageAlt ?? t('unauthorized.alt')} />
      <CenteredText
        variant={isMobile ? 'content-emphasis-06' : 'content-emphasis-07'}
      >
        {des ?? t('unauthorized.des')}
      </CenteredText>
      <CenteredText variant={isMobile ? 'content-04' : 'content-05'}>
        {complement ?? t('unauthorized.complement')}
      </CenteredText>
      <Button
        disabled={disabled}
        heightClass='large'
        onClick={actionCallback ?? redirectToLogin}
      >
        {action ?? t('unauthorized.action')}
      </Button>
    </MainContainer>
  )
}

export default Unauthorized
